import { render, staticRenderFns } from "./configureList.vue?vue&type=template&id=1677f22e&scoped=true&"
import script from "./configureList.vue?vue&type=script&lang=js&"
export * from "./configureList.vue?vue&type=script&lang=js&"
import style0 from "./configureList.vue?vue&type=style&index=0&id=1677f22e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1677f22e",
  null
  
)

export default component.exports